// GA4 funnel events. public/index.html defines `gtag` (queued into dataLayer
// until gtag.js loads), so events sent before the script arrives are kept.
type Params = Record<string, string | number | boolean>;
type Options = {
  /** Send at most once per page load for this key. */
  once?: string;
  /** Send at most once per browser for this key (e.g. a purchase). */
  persist?: string;
};

const sent = new Set<string>();
const PERSIST_PREFIX = "ga4_event:";

export function trackGa4(event: string, params: Params = {}, options: Options = {}): boolean {
  if (options.once) {
    if (sent.has(options.once)) return false;
    sent.add(options.once);
  }
  if (options.persist) {
    try {
      if (window.localStorage.getItem(PERSIST_PREFIX + options.persist)) return false;
    } catch { /* Storage may be unavailable. */ }
  }
  const gtag = (window as any).gtag;
  if (typeof gtag !== "function") return false;
  try {
    gtag("event", event, params);
  } catch {
    // Analytics must never break the page.
    return false;
  }
  if (options.persist) {
    try { window.localStorage.setItem(PERSIST_PREFIX + options.persist, "1"); } catch { }
  }
  return true;
}
